import React from 'react';

const Home = () => {
    return (
        <div className="home-container">
            <img
                src="/logosafite2.png"
                alt="Logo SAFITE"
                width={400}
            />
        </div>
    );
};

export default Home;
